module.exports = __webpack_public_path__ + "static/media/img82.372cb1bd.jpg";